import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DashboardTodolistStepMoveRequest as SchemaDashboardTodolistStepMoveRequest } from '../schemas/DashboardTodolistStepMoveRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Changes the current step in a todolist
 * @tags Dashboard
 * @summary Move between todolist steps
 */
export const MoveDashboardTodolistStepContentType = 'application/json' as const;
export type MoveDashboardTodolistStepRequest = SchemaDashboardTodolistStepMoveRequest;
export type MoveDashboardTodolistStepResponses = LinkCommonErrorResponses & {};
export type MoveDashboardTodolistStepResponseSuccess = undefined;
export type MoveDashboardTodolistStepSearchParams = undefined;
export type MoveDashboardTodolistStepPathParameters = undefined;
export const MoveDashboardTodolistStepUrl = '/dashboard/todolist/steps/move' as const;
export const MoveDashboardTodolistStepMethod = 'POST' as const;
export const getMoveDashboardTodolistStepUrl = (_params?: MoveDashboardTodolistStepPathParameters) =>
    MoveDashboardTodolistStepUrl;
